import { render, staticRenderFns } from "./mytab.vue?vue&type=template&id=52ba9d50&"
import script from "./mytab.vue?vue&type=script&lang=js&"
export * from "./mytab.vue?vue&type=script&lang=js&"
import style0 from "./mytab.vue?vue&type=style&index=0&id=52ba9d50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports